"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = exports.default = {
  props: {
    /* 列表数据源 */
    dataSource: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};